import React, { useCallback, useEffect, useState } from 'react';
import { ArrowLeft, CalendarDays } from 'lucide-react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { Loading } from '@/components/OpsUI';
import { FUNNEL } from './campaignUtils';
import { ContactsPanel } from './ContactsPanel';
import { MessageEditor } from './MessageEditor';
import { DeleteCampaignButton } from './DeleteCampaignButton';
import { FollowupPanel } from './FollowupPanel';

export function CampaignDetail({ id, canAct, isAdmin, onBack }) {
  const [c, setC] = useState(null);
  const load = useCallback(() => { api.get(`/campaigns/${id}`).then(({ data }) => setC(data)).catch(() => onBack()); }, [id, onBack]);
  useEffect(() => { load(); }, [load]);
  if (!c) return <Loading />;

  return (
    <div className="space-y-6" data-testid="campaign-detail">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <Button variant="ghost" size="sm" className="-ml-2 mb-1" onClick={onBack} data-testid="campaign-back-button">
            <ArrowLeft className="h-4 w-4 mr-1" />Despliegues Ministeriales
          </Button>
          <h1 className="text-2xl font-bold" data-testid="campaign-title">{c.name}</h1>
          <div className="text-xs text-[hsl(var(--muted-foreground))] flex items-center gap-1 mt-1">
            <CalendarDays className="h-3 w-3" />{c.event_date || 'Sin fecha'}
          </div>
        </div>
        {isAdmin && <DeleteCampaignButton campaign={c} onDeleted={onBack} />}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
        {FUNNEL.map(([k, label]) => (
          <Card key={k} className="p-4" data-testid={`campaign-stat-${k}`}>
            <div className="text-xs text-[hsl(var(--muted-foreground))]">{label}</div>
            <div className="text-2xl font-bold mt-1">{c.counts?.[k] ?? 0}</div>
          </Card>
        ))}
      </div>
      <Tabs defaultValue="contacts">
        <TabsList data-testid="campaign-tabs">
          <TabsTrigger value="contacts" data-testid="campaign-tab-contacts">Congregaciones</TabsTrigger>
          <TabsTrigger value="message" data-testid="campaign-tab-message">Mensaje de bienvenida</TabsTrigger>
          <TabsTrigger value="followup" data-testid="campaign-tab-followup">Seguimiento WhatsApp</TabsTrigger>
        </TabsList>
        <TabsContent value="contacts" className="mt-4"><ContactsPanel campaign={c} canAct={canAct} onChange={load} /></TabsContent>
        <TabsContent value="followup" className="mt-4"><FollowupPanel campaignId={c.id} canAct={canAct} /></TabsContent>
        <TabsContent value="message" className="mt-4"><MessageEditor campaign={c} canAct={canAct} onSaved={load} /></TabsContent>
      </Tabs>
    </div>
  );
}
